/*
 * AQS — mobile "hover" equivalents. On touch devices there's no hover, so
 * cards get their hover look (zoom / underline / arrow) when they scroll into
 * the centre of the viewport. Adds/removes `.aqs-incenter`; the CSS does the
 * rest (mobile only). Reduced-motion and desktop are skipped.
 */
(function () {
  if (window.__aqsMobileFx) return;
  window.__aqsMobileFx = true;

  var mq = window.matchMedia;
  if (mq && mq('(prefers-reduced-motion: reduce)').matches) return;
  if (mq && mq('(hover: hover)').matches) return; // desktop: real hover handles it
  if (!('IntersectionObserver' in window)) return;

  function init() {
    var cards = document.querySelectorAll(
      '.aqs-cats__card, .aqs-article__rel-card, .blog-post-item, .aqs-lbp__item, .aqs-times__item, .aqs-ev__shot, .aqs-lookbook__figure'
    );
    if (!cards.length) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (e) {
          e.target.classList.toggle('aqs-incenter', e.isIntersecting);
        });
      },
      // Only the centre band of the viewport counts as "in view".
      { rootMargin: '-42% 0px -42% 0px', threshold: 0 }
    );

    cards.forEach(function (c) {
      io.observe(c);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
